import { cloneDeep } from 'lodash'

export default {
  namespaced: true,
  state: {
    rowsToUpdate: {}
  },

  getters: {
    rowsToUpdate: state => state.rowsToUpdate
  },

  mutations: {
    updateRow(state, { id, key, value, originalValue }) {
      let rows = cloneDeep(state.rowsToUpdate)
      if (rows.hasOwnProperty(id)) {
        if (rows[id].hasOwnProperty(key)) {
          if (value === rows[id][key].originalValue) {
            delete rows[id][key]
            if (!Object.keys(rows[id]).length) {
              delete rows[id]
            }
          } else {
            rows[id][key].value = value
          }
        } else {
          rows[id][key] = { value, originalValue }
        }
      } else rows[id] = { [key]: { value, originalValue } }
      state.rowsToUpdate = rows
    },
    clearState: state => (state.rowsToUpdate = {})
  }
}
